import * as React from 'react';
import { Image } from '@cian/ui-kit';

import * as styles from './NewbuildingImage.css';

interface INewbuildingImageProps {
  url?: string;
  name?: string;
}

export const NewbuildingImage: React.FC<INewbuildingImageProps> = ({ url, name }) => {
  return (
    <div className={styles['image']}>
      <Image src={url || ''} alt={name} width={160} height={116} />
    </div>
  );
};
